import { render, staticRenderFns } from "./NoticeToast.vue?vue&type=template&id=9987c5ba&scoped=true&lang=pug&"
import script from "./NoticeToast.vue?vue&type=script&lang=js&"
export * from "./NoticeToast.vue?vue&type=script&lang=js&"
import style0 from "./NoticeToast.vue?vue&type=style&index=0&id=9987c5ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9987c5ba",
  null
  
)

export default component.exports